<div id="top"></div>
<app-navbar></app-navbar>
<br>

<div id="myappviewscroll">

</div>

<div style="background-color:#f5f5f5;width:99%" class="mx-auto d-block">       
    <p-tabView #pnl (onChange)="onSelect($event)" [activeIndex]="activeInexApp">
      <div *ngIf="loadAppRequest" >
        <p-progressBar  class="customProgress" mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
        <br>
      </div>
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="ui-helper-clearfix">
              <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">
               
                <table role="presentation">
                  <tr>
                    <td >
                      <i class="pi pi-file-o"></i>
                    </td>
                    <td style="text-align: right;">
                      

                       My Applications        
                    </td>
                  </tr>
                </table>  
                  
              </span>      
            </div>
         </ng-template>
          <div  style="background-color:#f5f5f5;width:100%" class="mx-auto d-block"> 
            <div class="break-msg" >      
              <p-messages key="appListKey" class="break-msg" class="aetna-msg" [(value)] ="applistMsg" [closable]="false"></p-messages>
              <p-messages key="updateappKeyApp" class="break-msg" class="aetna-msg" [(value)] ="updateMsgApp" [closable]="false"></p-messages>
            </div>
           
           <div class="ui-fluid container-fluid">
            <div class="row" >

              <div class="p-field col-md-12">
                <label for="search" class="aetna-table-header">Search By Application Name OR Callback URL</label>
              </div>
              <div class="p-field col-md-3">

               
                <br>
                <div class="ui-inputgroup">
                  <span class="ui-inputgroup-addon"><i style="background-color: #7d3f98;" class="pi pi-search"></i></span>
                                          
                  <input pInputText size="20"  placeholder="Search"  id="search"   type="text"  (keyup)="applyFilter($event)" >
                </div>
       
              </div>
               
              <div class="p-field col-md-3">
                  
                <br>
                  <button type="button"  class="aetna-button ui-button-raised ui-button-rounded" pButton icon="pi pi-refresh" label="Refresh" (click)="loadAppListOnClick()" style="margin-right:.5em"></button>
                 
              
              </div>
            </div>
            </div>
          <br>

          <div [hidden]="showNoSubData" style="margin-left: 40%;">
            <p class="aetna-table-header">No Application Data Available.</p>
          </div>
           <div class="example-container mat-elevation-z8" [hidden]="showGrid">
          
 
            <table mat-table  [dataSource]="dataSource" style="background-color: white;"  >
    
              <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->
            
              <!-- Position Column -->
              <ng-container matColumnDef="appName" sticky>
                <th mat-header-cell *matHeaderCellDef style="padding-right:12px ;"  class="aetna-table-header"> 
                  Application Name
                 
                </th>
                <td mat-cell style="width:20%;padding-right:12px ;" *matCellDef="let row"  class="text-break" data-label="App Name"> {{row['appName']}} 
                 
                  <span *ngIf="row.path=='production'" class="badge badge-pill badge-primary">{{row.path}}</span>
               
                  <span *ngIf="row.path=='sandbox'" class="badge badge-pill badge-secondary">{{row.path}}</span>
                

                </td>
              </ng-container>

              <ng-container matColumnDef="roleLabel">
                <th mat-header-cell *matHeaderCellDef style="padding-right:12px ;" class="aetna-table-header">I Am Representing</th>
                <td mat-cell style="width:20%;padding-right:12px ;" class="text-break" *matCellDef="let row"> 
                
                  <div *ngIf="!row.displayLine">
                        
                    <p-progressBar mode="indeterminate"></p-progressBar>
                  </div>

                  <div  *ngIf="row.displayLine" >
                    {{row['roleLabel']}}
                  </div>

                  
                 
                
                
                </td>
              </ng-container>
            
              <!-- Name Column -->
              <ng-container matColumnDef="callBackURL">
                <th mat-header-cell *matHeaderCellDef style="padding-right:12px ;" class="aetna-table-header"> Callback URL </th>
                <td mat-cell style="width:20%;padding-right:12px ;" class="text-break" *matCellDef="let row"> {{row['callBackURL']}}
                
              
                </td>
              </ng-container>
            
              <!-- Weight Column -->
              <ng-container matColumnDef="clientId">
                <th mat-header-cell *matHeaderCellDef style="padding-right:12px ;"  class="aetna-table-header"> Client Id </th>
                <td mat-cell  style="padding-right:12px"  *matCellDef="let row">  
                  <button style="width: 120px;" pButton class="aetna-button ui-button-raised ui-button-rounded" *ngIf="!row.render" label="Click to view" (click)="showClientIDM(row)"></button>
                    <div *ngIf="row.render" class="text-break">
                      {{row['clientId']}}
                    </div>
                    <button pButton class="aetna-button ui-button-raised ui-button-rounded" *ngIf="row.render" label="Hide" (click)="hideClientIDM(row)"></button>
                 
                </td>
              </ng-container>
            
              <!-- Symbol Column -->
              <ng-container matColumnDef="Subscription">
                <th mat-header-cell *matHeaderCellDef class="aetna-table-header text-break"> Subscription </th>
                <td mat-cell style="padding-right:6px" *matCellDef="let row"><button pButton (click)="showAppView(row)" style="width: 80px;" class="aetna-button ui-button-raised ui-button-rounded" label="View"> </button></td>
               
              </ng-container>
              <ng-container matColumnDef="Update App" >
                <th mat-header-cell *matHeaderCellDef   class="aetna-table-header text-break"> Update App </th>
                <td mat-cell   *matCellDef="let row"><button pButton (click)="updateApp(row)" class="aetna-button ui-button-raised ui-button-rounded" label="Update"> </button></td>
              </ng-container>
    
              <ng-container matColumnDef="API Products" >
                <th mat-header-cell *matHeaderCellDef style="padding-right:12px ;" class="aetna-table-header text-break"> API Products </th>
                <td mat-cell  *matCellDef="let row">
                  
                  <div *ngIf="!row.displayLine">
                        
                    <p-progressBar mode="indeterminate"></p-progressBar>
                  </div>
                  <div *ngIf="row.displayLine">
                        
                    <button pButton (click)="productSelectionUsingRole(row)" class="aetna-button ui-button-raised ui-button-rounded" label="Products">
                    
                    </button>
                  </div>
                  
                  
                </td>
              </ng-container>
            
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    

            </table>
            <mat-paginator aria-label="paginator" role="region"  class="aetna-table-header" [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
          </div >
        
          <div id="productsscrollmyapp">

          </div>
       
        
<!--
            <p-table #dt    [paginator]="true"  [columns]="appListCols" [value]="appList.appListView" [style]="{width: '100%'}"  [responsive]="true"  [rows]="5">
              <ng-template pTemplate="header" let-columns>
                  <tr>
                      <th style="width:20%">                
                        <label for=”app_name”> Application Name </label>
                        
                        <input id="app_name" pInputText type="text"  style="width:80%"
                        (input)="dt.filter($event.target.value, 'appName', 'contains')" />
                      <th style="width:20%">Callback URL</th>
                      <th style="width:15%">Client Id</th>             
                      <th style="width:15%">Subscription</th>  
                      <th style="width:15%">Update App</th>
                      <th style="width:15%">API Products</th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr>
                    <td class="text-break">
                      {{rowData['appName']}}
                      <label class="font-weight-bold">(Non-Production)</label>
                  </td>
                      <td class="text-break">
                        {{rowData['callBackURL']}}
                    </td>
                    <td>
                        <p-inplace closable="closable">
                          <span pInplaceDisplay>
                            Click to view
                            </span>
                           <span pInplaceContent>
                             {{rowData['clientId']}}
                           </span>
                         </p-inplace>
                      </td>
                      <td > <button pButton (click)="showAppView(rowData)"    class="aetna-button ui-button-raised ui-button-rounded" label="View"> </button></td>                                    
                      <td> <button pButton (click)="updateApp(rowData)"  class="aetna-button ui-button-raised ui-button-rounded" label="Update"> </button></td>
                      <td > <button pButton (click)="editApp(rowData)"   class="aetna-button ui-button-raised ui-button-rounded" label="Products"> </button></td> 
                  </tr>
              </ng-template>
            
              

              

          </p-table>
            -->
            
          <br>
         <div [hidden]="!viewAppRender">
          <app-viewapp  #subChild ></app-viewapp>
         
         </div>
           
         

         <app-updateapp *ngIf="updateAppRender" [appName]="selecetedApp.appName" [clientId]="selecetedApp.clientId" [credId]="selecetedApp.credId" [appCallBackUrl]="selecetedApp.callBackURL" [appSys]="selecetedApp.legacyInd" [appID]="selecetedApp.appID" [kid]="selecetedApp.kid" [jwksURL]="selecetedApp.jwksUrl" [chplProductId]="selecetedApp.chplId" [chplProductName]="selecetedApp.chplProductName" (appUpdatedData)="handleData($event)"></app-updateapp>
          <app-products *ngIf="editAppRender" [showDivOfPrd]="true" [appName]="selecetedApp.appName"  [appCallBackUrl]="selecetedApp.callBackURL" [appID]="selecetedApp.appID"  [pathInfo]="selecetedApp.path"></app-products>
        </div>
      </p-tabPanel>
      <p-tabPanel  >
       
        <ng-template pTemplate="header" >
          <div class="ui-helper-clearfix" >
              <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px;">
                
                <table role="presentation" >
                  <tr valign="center">
                    <td >
                      <i  style="font-size: 1em" class="pi pi-plus"></i>
                    </td>
                   
                    <td style="text-align: right;">
                     
                     

                     Create New       
                    </td>
                  </tr>
                </table> 
              </span>      
            </div>
         </ng-template>
       
       
        <div style="background-color:#f5f5f5;width:100%" class="mx-auto d-block"> 
            
              <p-panel >
                <p-header>
                  <div class="ui-helper-clearfix">
                     <h2>     <span class="ui-panel-title" style="font-size: 22px;display:inline-block;margin-top:2px;font-weight: 500;">Create New Application </span>    </h2>  
                    </div>
              </p-header>
             
              
              <form #newappform="ngForm"  autocomplete="off"  >
                <div class="ui-fluid container-fluid">
                  <div class="row" >
                    <div class="p-field col-md-12" class="break-msg">
                      <p-messages  key="createappKey" class="break-msg" class="aetna-msg" [(value)] ="msgs" [closable]="false" ></p-messages>
                      </div> 
                      <div class="p-field col-md-12" *ngIf="isEHRProd && !disableAppCreation">
                         <br>
                        <label for="chplePdNumL">CHPL Product Number <span style="color: red; font-weight: bold;">*</span></label>
                        <input type="text" class="form-control" #chplePdNumL='ngModel' name="chplePdNumL" [(ngModel)]="chplePdNum"   (blur)="chplePdNum= chplePdNum.trim();" required>
                        
                        <div *ngIf="chplePdNumL.touched">
                          <div *ngIf="chplePdNumL.errors?.required" class="text-danger">* Please enter CHPL Product Number</div> 
                         
                        </div>
                      </div>
                    <div class="p-field col-md-12" *ngIf="isEHRProd && !disableAppCreation">
                      <br/>
                      <label for="chplePdNameL">Product Name
                        <span style="color: red; font-weight: bold;">*</span>
                      </label>
                       <input type="text" class="form-control" #chplePdNameL='ngModel' name="chplePdNameL" [(ngModel)]="chplePdName" (blur)="chplePdName= chplePdName.trim();"  required>
                       <div *ngIf="chplePdNameL.touched">
                        <div *ngIf="chplePdNameL.errors?.required" class="text-danger">* Please enter CHPL Product Name</div> 
                       
                      </div>
                 
                  
                  
                      </div>
                   
                      <div class="p-field col-md-12" *ngIf="isEHRProd && !disableAppCreation">
                      <br/>
                        <label for="jwksUrlL">JWKS URL <span style="color: red; font-weight: bold;">*</span></label>
                        <input type="text" class="form-control" #jwksUrlL='ngModel' name="jwksUrlL" [(ngModel)]="jwksUrl"  (blur)="jwksUrl= jwksUrl.trim();"    required>
                        <div *ngIf="jwksUrlL.touched">
                          <div *ngIf="jwksUrlL.errors?.required" class="text-danger">* Please enter JWKS URL</div> 
                        
                        </div>
                   
                    </div>

                    <div class="p-field col-md-12" *ngIf="isEHRProd && !disableAppCreation">
                      <br/>
                        <label for="kidL">Key ID <span style="color: red; font-weight: bold;">*</span></label>
                        <input type="text" class="form-control" #kidL='ngModel' name="kidL" [(ngModel)]="kid"  (blur)="kid= kid.trim();"   required>
                        <div *ngIf="kidL.touched">
                          <div *ngIf="kidL.errors?.required" class="text-danger">* Please enter Key ID</div> 
                        
                        </div>
                   
                    </div>
                    <div class="p-field col-md-12" *ngIf="!disableAppCreation">
                      <br/>      
                            <label for="appNameL">Application Name <span style="color: red; font-weight: bold;">*</span></label>
                            <input type="text" class="form-control" #appNameL='ngModel' name="appNameL" [(ngModel)]="appName" minlength="1" maxlength="86"  (blur)="appName= appName.trim();" required>
                              
                            <div *ngIf="appNameL.touched">
                              <div *ngIf="appNameL.errors?.required" class="text-danger">* Please enter Application Name</div> 
                             
                            </div>
                   
                      </div>
                    <div class="p-field col-md-12" *ngIf="!disableAppCreation">
                      <br/>
                      <label for="callBackUrlL">Callback URL<span style="color: red; font-weight: bold;">*</span></label>
                      <input type="text" class="form-control" #callBackUrlL='ngModel' name="callBackUrlL" [(ngModel)]="callBackUrl" (blur)="callBackUrl= callBackUrl.trim();"  minlength="1" maxlength="100"   required>
                      
                      <div *ngIf="callBackUrlL.touched">
                        <div *ngIf="callBackUrlL.errors?.required" class="text-danger">* Please enter Callback URL</div> 
                       
                      </div>
                  
                    </div>

                  
                    <div class="p-field col-md-4">
                    <br>
                    
                      <label for="role">I Am Representing:</label>
                      <br>
                       <!-- (onChange)='changeEnvForPayer()' -->
                      <p-dropdown [disabled]="!disableAppCreation"  id="role" [options]="rolesOfDev" name="role" [(ngModel)]="roleValue" (onChange)='changeEnvForPayer()' placeholder="Please Select an Option"  required></p-dropdown>
                   </div>
                    <div class="p-field col-md-4">
                      <br>
                      <label for="appenv">Application Environment:</label>
                      <br>
                 
                      <p-dropdown  [disabled]="!disableAppCreation" id="appenv" [options]="path" name="appenv" [(ngModel)]="pathValue" placeholder="Please Select an Option"  required></p-dropdown>
                   </div>
                  <div class="p-field col-md-4">
                   
               
                
                <br>
                <label style="color: white;">Submit</label>

                 <br>
                <div *ngIf="!disableAppCreation"> 
                   <button pButton type="submit" label="Submit" #submit (click)= "createnewApp()"   [disabled]="appCreationDisabled" class="aetna-button ui-button-raised ui-button-rounded"></button>
                </div>

                <div *ngIf="disableAppCreation"> 
                  <button pButton type="submit" label="Continue" #continue  [disabled]="newappform.invalid"  (click)= "checkApprovalStatus()"  class="aetna-button ui-button-raised ui-button-rounded"></button>
               </div>
               <br>
                 <!--
                    <h4 class="aetna-header" style="margin-left: 10px;color: #7d3f98;">Coming Soon</h4>
                  -->
                  </div>
                  </div>
                 </div>
               </form>
              </p-panel>
          </div>
        </p-tabPanel>
    </p-tabView>
</div>


<p-dialog header="Access Denied" [modal]="true" [closable]="true" [(visible)]="accessDenyError" [style]="{width: '50vw'}" [baseZIndex]="10000">
  <div class="ui-fluid">
  <div class="p-field">
  <label for="Clientsecret">{{accessErrorMsg}}</label> 
 
</div>
  </div>
<p-footer>
   <button type="button" pButton  (click)="accessDenyError=false" label="Ok"class="aetna-button ui-button-raised ui-button-rounded" ></button>
   </p-footer>
</p-dialog>

